(() => {
  const closeDesktopDetails = (navigation, except = null) => {
    navigation.querySelectorAll('details[open]').forEach((details) => {
      if (details !== except) details.removeAttribute('open');
    });
  };

  const initDesktop = (navigation) => {
    if (navigation.dataset.momoReady === 'true') return;
    navigation.dataset.momoReady = 'true';
    const detailsList = [...navigation.querySelectorAll('details')];

    detailsList.forEach((details) => {
      details.addEventListener('toggle', () => {
        if (details.open) closeDesktopDetails(navigation, details);
      });

      const item = details.closest('.momo-nav-desktop__item');
      if (item && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        let closeTimer;
        item.addEventListener('mouseenter', () => {
          window.clearTimeout(closeTimer);
          closeDesktopDetails(navigation, details);
          details.setAttribute('open', '');
        });
        item.addEventListener('mouseleave', () => {
          closeTimer = window.setTimeout(() => details.removeAttribute('open'), 140);
        });
      }
    });

    navigation.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = navigation.querySelector('details[open]');
      if (!open) return;
      open.removeAttribute('open');
      open.querySelector('summary')?.focus();
    });

    document.addEventListener('pointerdown', (event) => {
      if (!navigation.contains(event.target)) closeDesktopDetails(navigation);
    });
  };

  const closeMobilePanel = (button) => {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    button.setAttribute('aria-expanded', 'false');
    if (panel) panel.hidden = true;
  };

  const initMobile = (navigation) => {
    if (navigation.dataset.momoReady === 'true') return;
    navigation.dataset.momoReady = 'true';
    const buttons = [...navigation.querySelectorAll('.momo-nav-mobile__toggle')];

    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const opening = button.getAttribute('aria-expanded') !== 'true';
        buttons.forEach((candidate) => {
          if (candidate !== button) closeMobilePanel(candidate);
        });
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        button.setAttribute('aria-expanded', opening ? 'true' : 'false');
        if (panel) panel.hidden = !opening;
      });
    });

    navigation.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openButton = navigation.querySelector('.momo-nav-mobile__toggle[aria-expanded="true"]');
      if (!openButton) return;
      closeMobilePanel(openButton);
      openButton.focus();
    });
  };

  const init = (root = document) => {
    root.querySelectorAll('.momo-navigation__desktop').forEach(initDesktop);
    root.querySelectorAll('[data-momo-mobile-navigation]').forEach(initMobile);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
